import React from 'react';
import { ArrowDown } from 'lucide-react';
import { ReportSection } from './ReportSection';
import { DeltaLine } from './DeltaLine';
import { formatReportValue } from '../../utils/reportFormat';
import type { ClubStoreMode, MonthlyClubReport } from '../../types/monthlyClubReport';
export function ClubHealthSection({
  report,
  showClubsLink = true,
  storeMode = 'several'
}: {
  report: MonthlyClubReport;
  /** Hidden when the Members by club section is turned off */
  showClubsLink?: boolean;
  storeMode?: ClubStoreMode;
}) {
  const clubCount = report.clubs.length;
  const isOneClub = storeMode === 'one';
  return <ReportSection id="club-health" title="Club health" data-id="element-3558" data-mp="10vdxixx8t5yx">
      <ul className="divide-y divide-[#E2E8F0] -my-2" data-id="element-3559" data-mp="15mm6xtykorc3">
        {report.health.map(metric => <li key={metric.label} className="py-4 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3" data-id="element-3560" data-mp="15op9fdgwwcxp">
            <div className="min-w-0" data-id="element-3561" data-mp="d6bilxtztr84">
              <div className="text-sm font-medium text-[#0F172A]" data-id="element-3562" data-mp="d5a3ni9uwkl4">{metric.label}</div>
              <p className="text-xs text-[#94A3B8] mt-1" data-id="element-3563" data-mp="1trxt7fatntbk">
                How it's worked out: {metric.how}
              </p>
            </div>
            <div className="sm:text-right flex-shrink-0" data-id="element-3564" data-mp="1ovzaa789j3ij">
              <div className="text-[20px] font-semibold text-[#0F172A] leading-tight" data-id="element-3565" data-mp="1k24l4o9w1wc2">
                {formatReportValue(metric.value, metric.format)}
              </div>
              <div className="mt-1 space-y-0.5 flex flex-col sm:items-end" data-id="element-3566" data-mp="1b30zbcjc72tv">
                <DeltaLine mode="value" current={metric.value} compared={metric.prev} label={report.prevShort} format={metric.format} data-id="element-3567" data-mp="1b0543vyvis94" />
                <DeltaLine mode="value" current={metric.value} compared={metric.yearAgo} label={report.yearAgoShort} format={metric.format} data-id="element-3568" data-mp="113jx553an72n" />
              </div>
            </div>
          </li>)}
        {showClubsLink && <li className="py-4 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3" data-id="element-3569" data-mp="2vhbekqrv6v8n">
          <div data-id="element-3570" data-mp="2rhsutybs4q7e">
            <div className="text-sm font-medium text-[#0F172A]" data-id="element-3571" data-mp="2rh9ayc2kjrqq">
              {isOneClub ? 'Members by pack and frequency' : 'Members by club'}
            </div>
            <p className="text-xs text-[#94A3B8] mt-1" data-id="element-3572" data-mp="tlcc2i0tdrd9">
              {isOneClub ? 'How members are split across your pack sizes and frequencies.' : `How members are split across your ${clubCount} clubs, by pack size and frequency.`}
            </p>
          </div>
          <a href="#members-by-club" className="inline-flex items-center gap-1 text-sm font-medium text-[#0EA5E9] hover:text-[#0284C7] hover:underline flex-shrink-0" data-id="element-3573" data-mp="jsmzfjtj27gc">
            See below
            <ArrowDown className="w-3.5 h-3.5" data-id="element-3574" data-mp="1chkhblttu28k" />
          </a>
        </li>}
      </ul>
    </ReportSection>;
}